<template>
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.4675 6.63822H10.8012V0H6.63822V6.63822H0V10.8012H6.63822V17.4675H10.8012V10.8012H17.4675V6.63822Z" fill="white"/>
</svg>
</template>